import { Link } from 'react-router-dom';

function PropertyNotFoundState({ error, returnTo }) {
  return (
    <div className="min-h-screen text-[#183228]">
      <main className="mx-auto w-[min(900px,calc(100%-40px))] py-12">
        <section className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-8 shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
          <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Eiendom ikke funnet</p>
          <h1 className="font-serif text-4xl font-semibold text-[#163127]">Denne boligen finnes ikke i portefoljen.</h1>
          <p className="mt-4 text-[1.05rem] leading-[1.7] text-[#355046]">
            {error || 'Gå tilbake til portefoljen for å velge en annen eiendom.'}
          </p>
          <Link
            className="mt-6 inline-flex min-h-12 items-center justify-center rounded-full bg-[#1d4c3b] px-[22px] font-semibold text-[#f9f5ee] no-underline"
            to={returnTo}
          >
            Tilbake til oversikten
          </Link>
        </section>
      </main>
    </div>
  );
}

export default PropertyNotFoundState;